import { Survey, SurveyQuestion } from 'types/survey';
import { Answer } from 'types/surveyResponse';
import { filterDependent } from 'utils/survey';
import { Selector } from 'components/ui/Selector';
import { useSurveyTranslation } from 'hooks/useSurveyTranslation';
import styles from './SelectorQuestion.module.scss';

interface IProps {
  surveyDefinition: Survey;
  question: SurveyQuestion;
  answer: Answer;
  siblingAnswers: Answer[];
  onChange: (answer: Answer) => void;
}

export const MultiselectQuestion = ({ surveyDefinition, question, answer, siblingAnswers, onChange }: IProps) => {
  const ts = useSurveyTranslation(surveyDefinition);
  const selected = Array.isArray(answer.value) ? answer.value : [];

  return (
    <div
      className={
        question.input === 'multiselect-fullwidth' ? styles.selectorQuestionFullWidth : styles.selectorQuestion
      }>
      {question.options
        ?.filter(o => filterDependent(o, siblingAnswers))
        .map((o) => (
        <Selector
          key={o.value}
          label={ts(o.name)}
          isChecked={selected.includes(o.value)}
          onSelect={() => {
            if (selected.includes(o.value)) {
              onChange({ ...answer, value: selected.filter((v) => v !== o.value) });
            } else {
              onChange({ ...answer, value: [...selected, o.value] });
            }
          }}
        />
      ))}
    </div>
  );
};
